import ReactDOM from 'react-dom';
import { ReactNode } from 'react';
import styles from './Modal.module.css';

type ModalProps = {
  children: ReactNode;
  onClose: () => void;
}

function Modal(props: ModalProps) {
  const portalTarget = document.getElementById('modal');

  if (portalTarget !== null) {
    return (
      <div>
        {ReactDOM.createPortal(
          <div
            role='presentation'
            className={styles.backdrop}
            onClick={props.onClose}
            onKeyDown={props.onClose}
          />,
          portalTarget,
        )}
        {ReactDOM.createPortal(
          <div className={styles.container}>
            {props.children}
          </div>,
          portalTarget,
        )}
      </div>
    );
  }
  return (
    <div />
  );
}

export default Modal;
